<template lang="html">
  <div class="model" v-if="loading">
    <div>
      <img src="../assets/images/loading.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes loading-animation {
  form {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.model {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  div{
    display: flex;
    align-items: center;
    justify-content: center;;
    width:88px;
    height:88px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);
    border-radius:8px;
    img {
      width: 34px;
      height: 34px;
      display: block;
      animation: loading-animation linear infinite 1s;
    }
  }
}
</style>
